<template>
  <div ref="house_hands_wrapper" class="slide house_hands_wrapper zoom" v-parallax-fit="parallax_wrapper">
    <div class="house_cropped" v-parallax-fit="house_cropped"></div>
    <div class="hand1" id="house_hand1" v-parallax-fit="hand1"></div>
    <div class="hand2" v-parallax-fit="hand2"></div>
    <div class="hand3_wrapper">
      <div class="hand3" v-parallax-fit="hand3"></div>
    </div>

    <div class="hand4" v-parallax-fit="hand4"></div>
    <div class="hand5" v-parallax-fit="hand5"></div>
    <div class="hand6" v-parallax-fit="hand6"></div>
    <div class="hand7" v-parallax-fit="hand7"></div>
    <div class="hand8" v-parallax-fit="hand8"></div>
    <div class="hand9" v-parallax-fit="hand9"></div>
    <div class="hand10" ref="hand10" v-parallax-fit="hand10"></div>

  </div>
</template>

<script>
export default {
  name: 'slide24',
  mounted() {
    const self = this;
    const slideRef = this.$refs.house_hands_wrapper;
    const slide20 = document.querySelector('#slide20');
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/13_14a.jpg',
          url: 'https://d3n8a8pro7vhmx.cloudfront.net/acceinstitute/pages/1153/attachments/original/1570049936/WallstreetLandlordsFinalReport.pdf?1570049936',
          link_title: {
			'en': 'Wall Street Landlords turn American Dream into a Nightmare',
			'es': 'Los propietarios de Wall Street convierten el sueño americano en una pesadilla'
		  }
        },
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/14b.jpg',
          url: 'https://docs.google.com/document/d/e/2PACX-1vRf_4Zk_OsCwZ4VmZH7SIgQzz5s2H4z3A75_V0SYUGHt_CazBZo0lQZD0nIWgDrv8cb-C171GdPfx47/pub',
          link_title: {
			'en': 'Finding Your Corporate Landlord',
			'es': 'Cómo encontrar a su arrendador corporativo'
		  }
        },
      ],
      text: {
		'en': 'Multiple reports have detailed rent increases, frequent eviction filings, and neglect of basic maintenance at properties owned by Invitation Homes / Starwood Waypoint Homes. In some areas, the largest SFR companies own a large percentage of all single family rentals in a given zip code - up to 12.5% in some areas. In Sacramento County, Invitation Homes / Starwood Waypoint Homes is the single largest private landowner in the county, and the second largest landowner in the country itself.',
		'es': 'Múltiples informes han detallado aumentos de alquiler, frecuentes presentaciones de desalojo y negligencia en el mantenimiento básico en propiedades propiedad de Invitation Homes / Starwood Waypoint Homes. En algunas áreas, las compañías SFR más grandes poseen un gran porcentaje de todos los alquileres de viviendas unifamiliares en un código postal determinado, hasta un 12,5 % en algunas áreas. En el condado de Sacramento, Invitation Homes / Starwood Waypoint Homes es el propietario privado más grande del condado y el segundo propietario más grande del país.'
	  }
    };
    const text = {
		'en': 'In the past 10 years alone, nine big Wall Street firms have fundamentally altered local rental landscapes across the country by eliminating the human aspects of the relationship between tenants and their landlord.',
		'es': 'Solo en los últimos 10 años, nueve grandes firmas de Wall Street han alterado fundamentalmente los panoramas locales de alquiler en todo el país al eliminar los aspectos humanos de la relación entre los inquilinos y sus propietarios.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.transform == 'translateY(0px) translateX(0px) rotate(45deg)') {
          slideRef.classList.add('running');
          slide20.classList.add('running');
          self.$readMore.value = text;
          self.$evidence.value = JSON.stringify(evidence);
        } else {
          slideRef.classList.remove('running');
          slide20.classList.remove('running');
        }
      });
    });

    this.mutationObserver.observe(this.$refs.hand10, {
      attributes: true,
      attributeFilter: ['style']
    });

  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
  data() {
    return {
		  mutationObserver: null,
      house_cropped: [
        {
          start: 31250,
          end: 31350,
          fromStyle: { opacity: 0 },
          toStyle: { opacity: 1 },
          easing: 'linear'
        },
        {
          start: 34000,
          end: 34050,
          fromStyle: { opacity: 1 },
          toStyle: { opacity: 0 },
          easing: 'linear'
        },
      ],
      parallax_wrapper: [
      ],
      hand1: [
        {
          start: 31500,
          end: 32500,
          fromStyle: { backgroundPositionY: '1000px' },
          toStyle: { backgroundPositionY: window.innerWidth < 600 ? '412px' : '55px' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { backgroundPositionY: window.innerWidth < 600 ? '412px' : '55px' },
          toStyle: { backgroundPositionY: '1000px' },
          easing: 'linear'
        }
      ],
      hand2: [
        {
          start: 31500,
          end: 32500,
          fromStyle: { backgroundPositionY: '1000px' },
          toStyle: { backgroundPositionY: '60px' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { backgroundPositionY: '60px' },
          toStyle: { backgroundPositionY: '1000px' },
          easing: 'linear'
        }
      ],
      hand3: [
        {
          start: 31500,
          end: 32500,
          fromStyle: { transform: 'translateY(840px) translateX(-290px) rotate(30deg)' },
          toStyle: { transform: 'translateY(235px) translateX(-50px) rotate(30deg)' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { transform: 'translateY(235px) translateX(-50px) rotate(30deg)' },
          toStyle: { transform: 'translateY(840px) translateX(-290px) rotate(30deg)' },
          easing: 'linear'
        }
      ],
      hand4: [
        {
          start: 31800,
          end: 32200,
          fromStyle: { transform: 'translateY(0px) translateX(-1200px) rotate(86deg)' },
          toStyle: { transform: 'translateY(0px) translateX(0px) rotate(86deg)' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { transform: 'translateY(0px) translateX(0px) rotate(86deg)' },
          toStyle: { transform: 'translateY(0px) translateX(-1200px) rotate(86deg)' },
          easing: 'linear'
        }
      ],
      hand5: [
        {
          start: 31800,
          end: 32200,
          fromStyle: { transform: 'translateY(-800px) translateX(-700px) rotate(142deg)' },
          toStyle: { transform: 'translateY(0px) translateX(0px) rotate(142deg)' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { transform: 'translateY(0px) translateX(0px) rotate(142deg)' },
          toStyle: { transform: 'translateY(-800px) translateX(-700px) rotate(142deg)' },
          easing: 'linear'
        }
      ],
      hand6: [
        {
          start: 31800,
          end: 32200,
          fromStyle: { transform: 'translateY(-800px) translateX(800px) rotate(220deg)' },
          toStyle: { transform: 'translateY(0px) translateX(0px) rotate(220deg)' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { transform: 'translateY(0px) translateX(0px) rotate(220deg)' },
          toStyle: { transform: 'translateY(-800px) translateX(800px) rotate(220deg)' },
          easing: 'linear'
        }
      ],
      hand7: [
        {
          start: 31800,
          end: 32200,
          fromStyle: { transform: 'translateX(900px) rotate(-90deg)' },
          toStyle: { transform: 'translateX(0px) rotate(-90deg)' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { transform: 'translateX(0px) rotate(-90deg)' },
          toStyle: { transform: 'translateX(900px) rotate(-90deg)' },
          easing: 'linear'
        }
      ],
      hand8: [
        {
          start: 31800,
          end: 32200,
          fromStyle: { transform: 'translateY(700px) translateX(700px) rotate(-45deg)' },
          toStyle: { transform: 'translateY(0px) translateX(0px) rotate(-45deg)' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { transform: 'translateY(0px) translateX(0px) rotate(-45deg)' },
          toStyle: { transform: 'translateY(700px) translateX(700px) rotate(-45deg)' },
          easing: 'linear'
        }
      ],
      hand9: [
        {
          start: 31800,
          end: 32200,
          fromStyle: { transform: 'translateY(700px) rotate(0deg)' },
          toStyle: { transform: 'translateY(0px) rotate(0deg)' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { transform: 'translateY(0px) rotate(0deg)' },
          toStyle: { transform: 'translateY(700px) rotate(0deg)' },
          easing: 'linear'
        }
      ],
      hand10: [
        {
          start: 31800,
          end: 32200,
          fromStyle: { transform: 'translateY(700px) translateX(-700px) rotate(45deg)' },
          toStyle: { transform: 'translateY(0px) translateX(0px) rotate(45deg)' },
          easing: 'linear'
        },
        {
          start: 33400,
          end: 33800,
          fromStyle: { transform: 'translateY(0px) translateX(0px) rotate(45deg)' },
          toStyle: { transform: 'translateY(700px) translateX(-700px) rotate(45deg)' },
          easing: 'linear'
        }
      ],
    };
  }
}
</script>

<style lang="scss">

.house_hands_wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: none;

  &.running {
    animation-duration: 4s;
    animation-iteration-count: 1;
    animation-name: house_shaking;
    animation-play-state: running;
  }
}

.house_cropped {
  position: fixed;
  left: calc(50% - 337px);
  top: calc(50% - 200px);
  width: 920px;
  height: 590px;
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_HouseCropped.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  transition: 1s;
  z-index: 16;
  @media(max-width: 600px) {
    left: 11px;
    top: calc(50% - 87px);
    width: 96.4vw;
    height: 350px;
  }
  @media(max-width: 400px) {
    top: calc(50% - 93px);
  }
}

.slide {
    position: fixed;
    transform-origin: center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 5;
}

.hand1 {
  position: fixed;
  top: calc(50% - 1023px);
  left: calc(50% - 265px);
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_Hand_1.png');
  background-position-x: center;
  background-position-y: 55px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 250px;
  height: 1020px;
  z-index: 11;
  transform: rotateZ(-31deg);
  transform-origin: bottom;
  transition: 0.5s;
  @media(max-width: 600px) {
    width: 124px;
    height: 880px;
    top: calc(50% - 825px);
    left: 24px;
    background-size: contain;
  }
}

.hand2 {
  position: fixed;
  top: calc(50% - 1018px);
  left: calc(50% + 267px);
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_Hand_2.png');
  background-position-x: center;
  background-position-y: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 250px;
  height: 1020px;
  z-index: 11;
  transform: rotateZ(31deg);
  transform-origin: bottom;
  transition: 0.5s;
  @media(max-width: 600px) {
    width: 130px;
    height: 520px;
    top: calc(50% - 446px);
    left: calc(58% + 55px);
    background-size: contain;
  }
  @media(max-width: 400px) {
    top: calc(50% - 446px);
    left: calc(58% + 15px);
  }
}

.hand3_wrapper {
  position: fixed;
  width: 450px;
  height: 800px;
  overflow: hidden;
  transform: rotateZ(-31deg);
  z-index: 11;
  top: calc(50% - 880px);
  left: calc(50% - 298px);
  @media(max-width: 600px) {
    width: 360px;
    height: 790px;
    top: calc(50% - 795px);
    left: calc(50% - 298px);
  }
  @media(max-width: 400px) {
    top: calc(50% - 775px);
    left: calc(50% - 308px);
  }
  .hand3 {
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_Hand_1.png');
    background-position-x: center;
    background-position-y: 55px;
    background-size: cover;
    background-repeat: no-repeat;
    width: 200px;
    height: 1020px;
    z-index: 11;
    transform: rotateZ(25deg);
    transform-origin: bottom;
    position: relative;
    bottom: 198px;
    left: -86px;
    transition: 0.5s;
    @media(max-width: 600px) {
      bottom: 18px;
      left: -196px;
      background-size: contain;
      width: 120px;
      height: 920px;
    }
  }

}

.hand4 {
  position: fixed;
  top: calc(50% - 935px);
  left: calc(50% - 1293px);
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_Hand_2.png');
  background-position-x: center;
  background-position-y: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 250px;
  height: 1020px;
  z-index: 11;
  transform: rotateZ(86deg);
  transform-origin: bottom;
  transition: 0.5s;
  @media(max-width: 600px) {
    background-size: contain;
    width: 140px;
    height: 740px;
    z-index: 17;
    top: calc(50% - 635px);
    left: calc(50% - 873px);
  }
}
.hand5 {
  position: fixed;
  top: calc(50% - 1846px);
  left: calc(50% - 716px);
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_CorporateHand_05.png');
  background-position-x: center;
  background-position-y: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 186px;
  height: 943px;
  z-index: 11;
  transform: rotateZ(142deg);
  transform-origin: bottom;
  transition: 0.5s;
  @media(max-width: 600px) {
    background-size: contain;
    width: 136px;
    height: 843px;
    top: calc(50% - 1488px);
    left: calc(50% - 626px);
  }
}
.hand6 {
  position: fixed;
  top: calc(50% - 1022px);
  left: calc(50% + 524px);
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_CorporateHand_06.png');
  background-position-x: center;
  background-position-y: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 250px;
  height: 943px;
  z-index: 11;
  transform: rotateZ(220deg);
  transform-origin: center;
  transition: 0.5s;
  @media(max-width: 600px) {
    background-size: contain;
    width: 137px;
    height: 793px;
    top: calc(50% - 702px);
    left: calc(50% + 204px);
  }
  @media(max-width: 400px) {
    top: calc(50% - 682px);
  }
}
.hand7 {
  position: fixed;
  top: calc(50% - 460px);
  left: calc(50% + 790px);
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_CorporateHand_07.png');
  background-position-x: center;
  background-position-y: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 250px;
  height: 943px;
  z-index: 11;
  transform: rotateZ(-90deg);
  transform-origin: center;
  transition: 0.5s;
  @media(max-width: 600px) {
    background-size: contain;
    width: 110px;
    height: 733px;
    z-index: 16;
    top: calc(50% - 270px);
    left: calc(50% + 380px);
  }
}
.hand8 {
  position: fixed;
  top: calc(50% + 85px);
  left: calc(50% + 742px);
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_CorporateHand_08.png');
  background-position-x: center;
  background-position-y: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 200px;
  height: 943px;
  z-index: 16;
  transform: rotateZ(-45deg);
  transform-origin: center;
  transition: 0.5s;
  @media(max-width: 600px) {
    background-size: contain;
    width: 100px;
    height: 723px;
    z-index: 16;
    top: calc(50% - 5px);
    left: calc(50% + 322px);
  }
}
.hand9 {
  position: fixed;
  top: calc(50% + 178px);
  left: calc(50% + 32px);
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_CorporateHand_09.png');
  background-position-x: center;
  background-position-y: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 200px;
  height: 943px;
  z-index: 16;
  transform: rotateZ(0deg);
  transform-origin: center;
  transition: 0.5s;
  @media(max-width: 600px) {
    background-size: contain;
    width: 100px;
    height: 483px;
    z-index: 16;
    top: calc(50% + 78px);
    left: calc(50% + 12px);
  }
}
.hand10 {
  position: fixed;
  top: calc(50% + 88px);
  left: calc(50% - 678px);
  background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/24_CorporateHand_10.png');
  background-position-x: center;
  background-position-y: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 200px;
  height: 943px;
  z-index: 16;
  transform: rotateZ(45deg);
  transform-origin: center;
  transition: 0.5s;
  @media(max-width: 600px) {
    background-size: contain;
    width: 110px;
    height: 690px;
    z-index: 16;
    top: calc(50% - 12px);
    left: calc(50% - 398px);
  }
}
</style>
